import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  delay?: number;
  variant?: 'cream' | 'gold' | 'green';
}
export function Section({
  children,
  delay = 0,
  variant = 'cream'
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-transparent',
    gold: 'bg-white/90 backdrop-blur-sm shadow-lg',
    green: 'bg-white/90 backdrop-blur-sm shadow-lg'
  };
  const padding = variant !== 'cream' ? 'py-8 md:py-12 px-5 md:px-8 rounded-2xl' : '';
  const hasAccent = variant !== 'cream';
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-20px',
    amount: 0.1
  }} transition={{
    duration: 0.4,
    delay: 0,
    ease: 'easeOut'
  }} className={`space-y-3 md:space-y-4 ${backgrounds[variant]} ${padding} relative overflow-visible`} data-id="element-83">
      {/* Bookmark-style accent bar */}
      {hasAccent && <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-1.5 bg-[#C87941] rounded-sm shadow-md" style={{
      height: '33.33%'
    }} data-id="element-84" />}
      {children}
    </motion.section>;
}